import { PluginMedia } from 'rwl-shared/dist/models/plugin/Plugin';
import { MediaCarousel, MediaVariants } from './MediaCarousel';
import styled from 'styled-components6';
import { mqDown, mqUp } from '../../../../theme';

const MediaContainer = styled.div`
    height: 100%;
    ${mqUp('xl')} {
        width: var(--rwl-jobCardMediaWidth-lg);
    }
    ${mqDown('xl')} {
        width: var(--rwl-jobCardMediaWidth-md);
    }
    ${mqDown('lg')} {
        width: var(--rwl-jobCardMediaWidth-sm);
    }
    ${mqDown('xs')} {
        width: var(--rwl-jobCardMediaWidth-xs);
    }
    display: flex;
    background-color: var(--rwl-background-level1);
`;

const StaticMapImage = styled.img`
    height: 100%;
    border-radius: var(--rwl-spacing-sm) 0 0 var(--rwl-spacing-sm);
    width: var(--rwl-jobCardMediaWidth-lg);
    object-fit: cover;
    ${mqUp('xl')} {
        aspect-ratio: 50/43;
    }
    ${mqDown('xl')} {
        aspect-ratio: 42/50;
        width: var(--rwl-jobCardMediaWidth-md);
    }
    ${mqDown('sm')} {
        aspect-ratio: 1/1;
        width: var(--rwl-jobCardMediaWidth-sm);
    }
    ${mqDown('xs')} {
        aspect-ratio: 35/50;
        width: var(--rwl-jobCardMediaWidth-xs);
    }
`;

const NoMediaPlaceholder = styled.div`
    align-self: center;
    width: -webkit-fill-available;
`;

const PlaceholderImg = styled.img`
    width: -webkit-fill-available;
`;

type JobMediaProps = {
    disabledCarousel?: boolean;
    media?: PluginMedia[];
    staticMapUrl?: string;
    style?: React.CSSProperties;
    variant?: MediaVariants;
    onChange?: (media: PluginMedia, index: number) => void;
};

export const JobMedia = ({
    disabledCarousel = false,
    media,
    staticMapUrl,
    variant = 'light',
    onChange,
}: JobMediaProps): JSX.Element | null => {
    return (
        <MediaContainer>
            {media?.length ? (
                <MediaCarousel
                    disabledCarousel={disabledCarousel}
                    images={media}
                    variant={variant}
                    onChange={onChange}
                />
            ) : staticMapUrl ? (
                <StaticMapImage src={staticMapUrl} />
            ) : (
                <NoMediaPlaceholder>
                    <PlaceholderImg
                        className="placeholder-image"
                        src="https://app.realworklabs.com/placeholder.png"
                    />
                </NoMediaPlaceholder>
            )}
        </MediaContainer>
    );
};
